<template>
  <div class="bottomBar">
    <div class="body">
      <div class="itemView">
      

        <div class="item">
          <div class="title2">
            Canales de Contacto
          </div>
          <div class="text2" >
            Nombre de empresa: VOCASSIO S.A.C
          </div>
          <!-- <div class="text2" >
            Dirección de la empresa: Cl 19 A No. 24 - 28 Bogotá D.C. Bogotá
          </div> -->
         
          <div class="text2" >
            Correo electrónico:  atencioncliente@vocassiosac.com
          </div>
          
          <!-- <div class="text2" >
            Número de contacto: <a  style="color: #FFFFFF;" :href="`tel:${kefu_phone}`">+{{ kefu_phone }}  </a>
          </div> -->
         
          <div class="text2" >
            Horas de trabajo: 9: 00-18: 00 (días hábiles)
          </div>
        

        </div>
      </div>
     
      <div class="describe2">
        Copyright © 2025 VOCASSIO S.A.C.. All rights reserved
      </div>
     
    </div>

  </div>
</template>

<script>
export default {
  name: 'bottomBar',
  data() {
    return {
      kefu_phone:'573138293087'
    }
  },
  computed: {

  },
 
  mounted() {

  },

  methods: {
    navTo(url) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.$router.push(url).catch(err => console.log(err));

    },
  }
}
</script>
<style scoped lang="scss">


  .bottomBar {
    background: #211C2B;

    .body {
      max-width: 1080px;
      width: 100%;
      padding: 50px 15px;
      margin: 0 auto;
      .itemView {
        margin-bottom: 10px;
      
        display: flex;

        .one {
          margin-right: 90px !important;
        }

        .item {
          margin-right: 50px;
          .title1 {
            font-weight: 400;
            font-size: 15px;
            color:#FFFFFF;
            line-height: 32px;
            text-align: left;
            margin-bottom: 20px;
          }

          .title2 {
            font-weight: 600;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 32px;
            text-align: left;
            margin-bottom: 20px;
          }

          .imgs {
            margin-top: 30px;
            margin-bottom: 30px;
            display: flex;
            justify-content: flex-start;


            .img {
              display: block;
              width: 36px;
              height: 36px;
              margin-right: 12px;
            }
          }

          .text1 {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            color:#FFFFFF;
            text-align: left;

            a {
              color:#FFFFFF;
              text-decoration: none;
            }
          }

          .text2 {
            font-weight: 600;
            font-size: 15px;
            color:#FFFFFF;
            line-height: 30px;
            text-align: left;
            cursor: pointer;
            
          }

        }
      }

      .describe {
        margin-top: 24px;
        margin-bottom: 14px;
        font-weight: 400;
        font-size: 15px;
        color:#FFFFFF;
        line-height: 18px;
        text-align: left;
      }

      .describe2 {
        font-weight: 400;
        font-size: 13px;

color: rgba(245,247,250,0.5);
        line-height: 18px;
        text-align: center;
      }
    }
  }


</style>